import {dawaAutocomplete} from 'dawa-autocomplete2';

document.querySelectorAll('.search-button').forEach(button => {
    button.addEventListener('click', function() {
      this.closest('form').submit()
    });
})

const searchIcon = document.querySelector('#search-icon');
if (searchIcon) {
    searchIcon.addEventListener('click', function() {
    const searchElement = document.querySelector('.search-menu');
    if (searchElement.classList.contains('visible')) {
        searchElement.classList.remove('visible');
    } else {
        document.querySelector('.header-submenu').style.display = 'none';
        searchElement.classList.add('visible');
        searchElement.querySelector('input').focus();
    }
    })
}


document.querySelectorAll('.search-church').forEach(form => {
    form.addEventListener('submit', function(e) {
        e.preventDefault(); 
    });
    dawaAutocomplete(form.querySelector('input'), {
        adgangsadresserOnly: true,
        select: function(selected) {
            if (!selected.data.href) {
                return;
            }
            window.location.href = form.action + '?addressUrl=' + selected.data.href + '#dawasearchfield';
        }
    });
})